export default "__VITE_ASSET__CrCiDWlU__"